module.exports = __webpack_public_path__ + "roboto-medium-webfont-69c55fc2fe77d38934ea98dc31642ce6.woff2";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/fonts/roboto/roboto-medium-webfont.woff2
// module id = 836
// module chunks = 76